import "./logout.css"
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import Alert from 'react-bootstrap/Alert';
import {useNavigate} from "react-router-dom";

function Logout() {

    const {t} = useTranslation()
    const [show, setShow] = useState(false);
    const navigate = useNavigate()

    const handleLogout = () => {
        localStorage.clear();
        navigate('/login');
    };

    return (
        <div className="logout">
            <div className="logout_btn_part">
                <button className="logout_btn" onClick={() => setShow(!show)}>
                    <span className="logout_btn_text">{t('logout')}</span>
                </button>
            </div>
            {show &&
                <Alert variant="dark">
                    {t('logout_modal.logout_text')}
                    <div className="alert_btns">
                        <button onClick={handleLogout} className="logout_ok_btn_link">{t('logout_modal.ok')}</button>
                        <button className="logout_cancel_btn" onClick={() => setShow(!show)}>{t('logout_modal.cancel')}</button>
                    </div>
                </Alert>
            }
        </div>
    )
}

export default Logout